import React from 'react';
import dynamic from 'next/dynamic';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { useAppConfig } from '@/hooks/useAppConfig';

import animationData from '../library-portal/components/Orb/orb.lottie.json';
import { orbBorder, orbText } from '../library-portal/components/Orb/styles';
export const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface CoachOrbButtonProps {
  onClick: () => void;
}

export function CoachOrbButton(props: CoachOrbButtonProps) {
  const { onClick } = props;
  const { t } = useTranslation(['Common']);
  const { isMobile } = useScreen();

  const {
    site: { chatbot },
  } = useAppConfig();

  return (
    <Stack
      className={cn(orbBorder, '!h-[3.4rem]', isMobile ? 'mx-8 !w-[3.6rem]' : 'mx-14 !w-[9.6rem]')}
      onClick={onClick}>
      <Stack alignItems="center" className={cn('orb-content cursor-pointer')} direction="row">
        <Lottie animationData={animationData} loop={false} style={{ width: 34, height: 34 }} />
        {isMobile ? null : (
          <Typography className={cn(orbText)} variant="body-short-01">
            {t('Common:KnowledgeBase.Coach')}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
